import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode3({ name, brannd, typee = null }) {
  return (
    <ReferanceAsyncSelect
      name={name}
      labelCategory={brannd === 'ZaraHome' ? 'LABEL9 KARTI' : 'FİYAT KARTI'}
      extraFilter={typee === 'Bedlinen' ? (option) => option.label === 'LABEL9 52X90 DUVET' : undefined}
    />
  )
}
